module.exports = __webpack_public_path__ + "img/thumbnail_RedPanda_j_normal.ee326046.png";